<template>
  <div class="image-carousel">
    <ImagesFullscreen v-show="showImagesFullscreen" :images="images" :startIndex="startIndex" :show="showImagesFullscreen" @close="showImagesFullscreen = !showImagesFullscreen"></ImagesFullscreen>
    <div class="image-carousel-image-wrapper" @click="clickSingleImage">
      <div class="image-carousel-image" :class="{ 'image-carousel-image-active': (activeIndex === index) }" v-for="(image, index) in images" :key="index" :style="setImage(index)"></div>
    </div>
    <button class="button-reset image-carousel-prev-button" type="button" v-show="totalImages > 1" @click="prevImage()">
      <i class="fas fa-angle-left"></i>
    </button>
    <button class="button-reset image-carousel-next-button" type="button" v-show="totalImages > 1" @click="nextImage()">
      <i class="fas fa-angle-right"></i>
    </button>
    <div class="image-carousel-overlay">
      <span class="image-carousel-overlay-counter">{{ activeIndex + 1 }} av {{ totalImages }}</span>
      <button class="button-reset image-carousel-overlay-images-button" type="button" @click="clickExpandImages"><i class="fas fa-expand"></i></button>
    </div>
  </div>
</template>

<script>
import ImagesFullscreen from '@/components/ImagesFullscreen.vue'

export default {
  name: 'ImageCarousel',
  props: ['images'],
  components: {
    ImagesFullscreen
  },
  data () {
    return {
      showImagesFullscreen: false,
      activeIndex: 0,
      startIndex: 0,
      totalImages: 0
    }
  },
  methods: {
    nextImage () {
      let index = this.activeIndex + 1
      if (index >= this.images.length) {
        index = 0
      }

      this.activeIndex = index
    },
    prevImage () {
      let index = this.activeIndex - 1
      if (index < 0) {
        index = this.images.length - 1
      }

      this.activeIndex = index
    },
    setImage (index) {
      return {
        'background-image': 'url("' + this.images[index].url + '")'
      }
    },
    clickSingleImage () {
      this.startIndex = this.activeIndex
      this.showImagesFullscreen = true
    },
    clickExpandImages () {
      this.startIndex = 0
      this.showImagesFullscreen = true
    }
  },
  mounted () {
    this.totalImages = this.images.length
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.image-carousel {
  background-color: map-get($colors, gray-whiter);
  margin-left: -16px;
  margin-right: -16px;
  position: relative;
  display: flex;
  justify-content: center;

  @include breakpoint-up($md) {
    margin-left: 0;
    margin-right: 0;
  }
}

.image-carousel-image-wrapper {
  width: 100%;
}

.image-carousel-image {
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: center;
  background-position-y: center;
  cursor: zoom-in;
  width: 100%;
  padding-bottom: 75%;
  position: absolute;
  top: -9999px;
  left: -9999px;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(.68,-0.55,.27,1.55);
}

.image-carousel-image-active {
  position: static;
  opacity: 1;
}

.image-carousel-prev-button,
.image-carousel-next-button {
  background-color: rgba(0,0,0,0.7);
  cursor: pointer;
  font-size: 32px;
  width: 40px;
  height: 40px;
  margin-top: -16px;
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.image-carousel-prev-button:hover,
.image-carousel-next-button:hover {
  background-color: rgba(0,0,0,0.8);
}

.image-carousel-prev-button {
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  left: 0;
}

.image-carousel-next-button {
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  right: 0;
}

.image-carousel-prev-button .fas,
.image-carousel-next-button .fas {
  color: #fff;
  font-size: 3.2rem;
  z-index: 10;
}

.image-carousel-overlay {
  position: absolute;
  right: 4px;
  bottom: 4px;
  display: flex;
}

.image-carousel-overlay-counter,
.image-carousel-overlay-images-button {
  background-color: rgba(0,0,0,0.7);
  border: 1px solid #000;
  border-radius: 3px;
  color: #fff;
  font-weight: 700;
  padding: 4px 8px;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.image-carousel-overlay-images-button {
  cursor: pointer;
  margin-left: 4px;
}

.image-carousel-overlay-images-button:hover {
  background-color: rgba(0,0,0,0.8)
}
</style>
